export default {
  ALL_SCHOOLS (state, data) {
    state.all_schools = data.data
  }
}
